import { getPaperDetails, Paper } from "helpers/api";
import { getCite, ICite } from "helpers/cite";
import { downloadRIS } from "helpers/export";
import { useCallback, useState } from "react";

const initial = {
  mla: "",
  apa: "",
  chicago: "",
  bibtex: "",
  harvard: "",
};

/**
 * @hook usePaperCite
 * @description Hooks for cite.
 * @api openCite = will be true if native cite doesn't support
 * @api handleCite = function for cite
 * @api handleCloseCite = function for set openCite is false
 * @api citeData = state metadata cite
 * @api setCiteData = function for set metadata cite
 * @example
 * const { closeCiteModal, isCiteModalOpen, citeData, downloadCitedPaperRis, openCiteModal } = usePaperCite();
 */
const usePaperCite = () => {
  const [isCiteModalOpen, setCiteModalOpen] = useState(false);
  const [citeData, setCiteData] = useState<ICite>(initial);
  const [paper, setPaper] = useState<Paper>();

  const openCiteModal = (item: Paper) => {
    const data = getCite({
      authors: item?.authors,
      author: item.primary_author,
      journal: item.journal,
      title: item.title,
      year: item.year,
      doi: item.doi,
      volume: item.volume,
      pages: item.pages,
    });
    setCiteData(data);
    setPaper(item);
    setTimeout(() => {
      setCiteModalOpen(true);
    });
  };

  const closeCiteModal = () => {
    setCiteModalOpen(false);
    setTimeout(() => {
      setCiteData(initial);
    }, 500);
  };

  const downloadCitedPaperRis = useCallback(async () => {
    const paperDetails = await getPaperDetails(paper?.paper_id as string);
    downloadRIS([paperDetails], paperDetails.title);
  }, [paper]);

  return {
    closeCiteModal,
    isCiteModalOpen,
    citeData,
    downloadCitedPaperRis,
    openCiteModal,
  };
};

export default usePaperCite;
